import { featureFlags } from 'client-lib';
import { useEffect } from 'react';

export const useInjectCIAMScript = (): void => {
  const isCIAMEnabled = featureFlags.get('is-ciam-logout-enabled');

  useEffect(() => {
    if (!isCIAMEnabled) {
      return;
    }

    const ciamScriptSrc = '/ciam/components/all/v1/main.js';

    if (window.CIAM || document.querySelector(`script[src="${ciamScriptSrc}"]`)) {
      return;
    }

    const script = document.createElement('script');

    script.src = ciamScriptSrc;
    script.type = 'module';
    script.async = true;

    document.head.appendChild(script);
  }, [isCIAMEnabled]);
};
